import React from 'react';
import { Image } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/image.less';

export default Image;
